// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store'
import './less/base.less';
// 引入 Vant 库
import Vant from 'vant';
import 'vant/lib/index.css';
// 字典
import {getDicts} from "@/api/wx/dict/data";
import {selectDictLabel, selectDictLabels} from "@/utils/ruoyi";
// 字典数据组件
import DictData from '@/components/DictData'
import './permission' // permission control
const VConsole = require('./utils/vconsole');
Vue.config.ignoredElements = ['wx-open-launch-weapp']
// 全局方法挂载
Vue.prototype.getDicts = getDicts
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.config.productionTip = false;

Vue.use(Vant);
DictData.install()

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js